export default __webpack_public_path__ + "static/media/help2.4b309b0c.svg";